import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 40,
	viewBox: "0 0 32 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 4C1 2.34315 2.34315 1 4 1H15.9289C16.9897 1 18.0071 1.42143 18.7573 2.17157L29.8283 13.2426C30.5785 13.9928 30.9999 15.0102 30.9999 16.071V35.9999C30.9999 37.6567 29.6568 38.9999 27.9999 38.9999H4C2.34315 38.9999 1 37.6567 1 35.9999V4Z",
		fill: "white",
		stroke: "#0E4EFB",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M29.5858 13L22 13C20.3431 13 19 11.6568 19 9.99997V2.41421L29.5858 13Z",
		fill: "white",
		stroke: "#0E4EFB",
		strokeWidth: 2
	})]
});
export default SvgPage;
